import * as React from "react";

interface PropsType {
  warning: void | string;
}

export default function FieldWarning({ warning }: PropsType): JSX.Element {
  if (!warning) return null;

  return (
    <div className="form--field-warning">
      <i className="fas fa-exclamation-triangle" />
      <p>{warning}</p>
    </div>
  );
}
